import PageBase from '@glittr/frontend-core/src/core/v2/app/pageBase';
import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';
import Vue from 'vue';
import LookupRequestModel from '../../../../../../../services/v2/model/lookup-request-model';
import { WidgetConfig } from '../../../../../../../components/il-widget-tester.vue.model';
import GuidEventLookupModel from '../../../../../../../services/v2/model/guid-event-lookup-model';

export default class CompanyRegistrationTestingPage extends PageBase {
  public widgetConfig: WidgetConfig | undefined = undefined;

  public eventItems: GuidEventLookupModel[] | undefined;

  async initialize(): Promise<void> {
    await this.eventsDataSource.select();
    await this.loadEventLookup();
  }

  public eventsDataSource = new DataSource({
    selectCommand: () => {
      const req = new LookupRequestModel();
      return Vue.$service.v2.api.tdg_Events.eventLookup(req);
    },
  });

  async loadEventLookup() {
    if (this.eventsDataSource.data) {
      const res = this.eventsDataSource.data;

      this.eventItems = res.items.map((i) => {
        const model = new GuidEventLookupModel();
        model.id = i.data.id;
        model.caption = i.data.caption;
        return model;
      });

      const items = this.eventItems.map((e) => ({
        id: e.id!,
        caption: e.caption!,
      }));

      const defaultId = items.length > 0
        ? items[items.length - 1].id
        : 0;

      this.widgetConfig = {
        route: { value: '/_widget/companies/registration', hidden: true },
        'current-eventidentifier': {
          label: 'Event ID',
          value: defaultId,
          type: 'select',
          required: true,
          items,
        },
        'widget-detailurl': { label: 'Detail Url', value: '/_admin/testing/widget/companies/registration' },
        'widget-successelementid': { label: 'Success ID', default: 'widget-success' },
      } as unknown as WidgetConfig;

      this.eventsDataSource.filter.eventIdentifier = defaultId;
    }
  }
}
